<p-dialog [(visible)]="display" (onHide)="onHide()" (onShow)="onShow()" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '55vw',height: 'auto'}" class="gl-p-dialog" [modal]="true" [resizable]="false">
    <ng-template class="p-dialog-title" pTemplate="header">
      <div>
        <svg width="20px" height="20px" viewBox="0 -0.5 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>grid [#ffffff]</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-219.000000, -200.000000)" fill="#ffffff"> <g id="icons" transform="translate(56.000000, 160.000000)"> <path d="M181.9,54 L179.8,54 C178.63975,54 177.7,54.895 177.7,56 L177.7,58 C177.7,59.105 178.63975,60 179.8,60 L181.9,60 C183.06025,60 184,59.105 184,58 L184,56 C184,54.895 183.06025,54 181.9,54 M174.55,54 L172.45,54 C171.28975,54 170.35,54.895 170.35,56 L170.35,58 C170.35,59.105 171.28975,60 172.45,60 L174.55,60 C175.71025,60 176.65,59.105 176.65,58 L176.65,56 C176.65,54.895 175.71025,54 174.55,54 M167.2,54 L165.1,54 C163.93975,54 163,54.895 163,56 L163,58 C163,59.105 163.93975,60 165.1,60 L167.2,60 C168.36025,60 169.3,59.105 169.3,58 L169.3,56 C169.3,54.895 168.36025,54 167.2,54 M181.9,47 L179.8,47 C178.63975,47 177.7,47.895 177.7,49 L177.7,51 C177.7,52.105 178.63975,53 179.8,53 L181.9,53 C183.06025,53 184,52.105 184,51 L184,49 C184,47.895 183.06025,47 181.9,47 M174.55,47 L172.45,47 C171.28975,47 170.35,47.895 170.35,49 L170.35,51 C170.35,52.105 171.28975,53 172.45,53 L174.55,53 C175.71025,53 176.65,52.105 176.65,51 L176.65,49 C176.65,47.895 175.71025,47 174.55,47 M167.2,47 L165.1,47 C163.93975,47 163,47.895 163,49 L163,51 C163,52.105 163.93975,53 165.1,53 L167.2,53 C168.36025,53 169.3,52.105 169.3,51 L169.3,49 C169.3,47.895 168.36025,47 167.2,47 M181.9,40 L179.8,40 C178.63975,40 177.7,40.895 177.7,42 L177.7,44 C177.7,45.105 178.63975,46 179.8,46 L181.9,46 C183.06025,46 184,45.105 184,44 L184,42 C184,40.895 183.06025,40 181.9,40 M174.55,40 L172.45,40 C171.28975,40 170.35,40.895 170.35,42 L170.35,44 C170.35,45.105 171.28975,46 172.45,46 L174.55,46 C175.71025,46 176.65,45.105 176.65,44 L176.65,42 C176.65,40.895 175.71025,40 174.55,40 M169.3,42 L169.3,44 C169.3,45.105 168.36025,46 167.2,46 L165.1,46 C163.93975,46 163,45.105 163,44 L163,42 C163,40.895 163.93975,40 165.1,40 L167.2,40 C168.36025,40 169.3,40.895 169.3,42" id="grid-[#ffffff]"> </path> </g> </g> </g> </g></svg>
          <strong class="mx-2">{{ 'MULTISCREEN.TITLE.DIALOG' | translate }}</strong>
      </div>
    </ng-template>
    <div class="dialog-body-container">
      <div class="p-fluid p-formgrid p-grid">
        <div class="dialog-form-container">
          <div class="d-flex flex-column mt-2">
            <div *ngIf="!this.showSaveMultiview" class="h-auto row">
                <div class="col-xxl-5 col-xl-4 col-lg-12 d-flex flex-column justify-content-center px-3 pb-xl-0 pb-lg-3 ">
                    <label class="my-2">{{'COMMON.OPERATION' | translate}}</label>
                    <p-dropdown
                        class="mb-4"
                        [options]="operations"
                        [(ngModel)]="selectedOperation" optionLabel="nombre" optionValue="id"
                        [appendTo]="'body'"
                        [showClear]="true"
                        [filter]="true" filterBy="nombre" [placeholder]="'GENERAL.SELECT' | translate"
                        (ngModelChange)="changeOperation()">
                    </p-dropdown>

                    <label for="" class="my-2">{{'FIELDS.UNITS' | translate}}</label>
                    <p-multiSelect
                        class="mb-4"
                        [filter]="true"
                        [options]="unitItems"
                        defaultLabel="Unidades"
                        optionLabel="nombre"
                        [(ngModel)]="multiviewService.selectedUnits"
                        (onChange)="changeUnits()"
                        [appendTo]="'body'">
                    </p-multiSelect>

                    <hr>
                    <label for="" class="my-2">{{ 'MULTISCREEN.LABELS.SAVED_VIEWS' | translate }}</label>
                    <p-dropdown
                      [options]="views"
                      optionLabel="name"
                      [filter]="true"
                      filterBy="name"
                      [(ngModel)]="selectedGroup"
                      [showClear]="true"
                      [placeholder]="'COMMON.GROUP' | translate"
                      (onChange)="onSelectMultiview($event)"
                      [appendTo]="'body'"
                    >
                      <ng-template let-country pTemplate="item">
                          <div class="d-flex justify-content-between align-items-center gap-2">
                            <div>{{ country.name }}</div>
                            <p-button icon="pi pi-times" styleClass="p-button-rounded p-button-danger p-button-text" (click)="deleteMultiview(country.name);"></p-button>
                          </div>
                      </ng-template>
                    </p-dropdown>
                </div>
                <div class="col-xxl-7 col-xl-8 col-lg-12 d-flex flex-column justify-content-center align-items-center px-3 pt-xl-0 pt-lg-3 ">
                    <div class="d-flex justify-content-between w-100">
                      <label for="">
                        {{ selectedGroup ? ('MULTISCREEN.LABELS.VIEW' | translate) + ': ' + selectedGroup.name : ('MULTISCREEN.LABELS.VIEW' | translate) }}
                      </label>
                      <div>
                      <i *ngIf="multiviewService.selectedUnits.length > 0"
                        (click)="itJustCleaned=true; clearPreview()"
                        class="pi pi-trash"
                        [pTooltip]="'MULTISCREEN.ACTIONS.CLEAR_VIEW' | translate"
                        tooltipPosition="left"
                        style="font-size: 1rem">
                      </i>
                      </div>
                    </div>
                    <div class="preview-grid-container">
                      <ng-container *ngIf="!viewTemplateGroup; else multiviewGrouped">
                        <app-preview [items]="multiviewService.selectedUnits" (itemsChange)="onGridChange($event)"></app-preview>
                      </ng-container>
                      <ng-template #multiviewGrouped>
                        <div class="preview-group-container">
                          <div class="group-container">
                            <input
                              type="text"
                              [(ngModel)]="currentMultiview.title_group"
                              [placeholder]="'COMMON.UNNAMED_GROUP' | translate"
                              class="group-name"
                            />
                            <p-badge [value]="multiviewService.selectedUnits.length" [pTooltip]="'N° de Unidades'"></p-badge>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                    <div *ngIf="multiviewService.selectedUnits.length>1" class="d-flex align-items-center justify-content-center w-100 mt-2">
                      <!-- <span class="mb-1">{{ (isGrouped) ? 'Grupo' : 'Simple' }}</span>&nbsp;&nbsp;&nbsp;
                      <p-inputSwitch [(ngModel)]="isGrouped" (onChange)="onChangeTypeIsGroup()"></p-inputSwitch> -->

                      <!-- SelectButton Alternative -->
                      <p-selectButton class="w-auto" [options]="stateIsGrouped" [(ngModel)]="isGrouped" (ngModelChange)="onChangeTypeIsGroup()" optionLabel="label" optionValue="value"></p-selectButton>
                    </div>
                </div>
            </div>
            <div *ngIf="this.showSaveMultiview" class="row h-auto">
              <div class="d-flex flex-column justify-content-center text-center gap-4">
                <div class="d-flex justify-content-center ">
                  <h4 class="my-2">{{ 'MULTISCREEN.MESSAGE.CONFIRM_SAVE_VIEW' | translate }}</h4>
                </div>
                <div class="d-flex justify-content-center">
                  <p-selectButton class="w-25" [options]="stateOptions" [(ngModel)]="saveMultiviewOption" optionLabel="label" optionValue="value"></p-selectButton>
                </div>
                <div *ngIf="saveMultiviewOption == 'si' && currentMultiview" class="d-flex justify-content-center align-items-center gap-2">
                  <label class="fs-6">{{ 'MULTISCREEN.LABELS.VIEW_NAME' | translate }}:</label>
                  <div class="flex flex-column gap-2">
                    <input type="text" pInputText
                      [(ngModel)]="currentMultiview.name"
                      (input)="isValidGroupName()"
                      [maxlength]="30"
                      [minlength]="1"
                      pTooltip="Solo letras, números y guiones (-)"
                      tooltipPosition="right"
                      hideDelay="1000"
                      appAlphaNumericDash
                      #nameInput
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row d-flex justify-content-end">
                <div class="col d-flex justify-content-center align-items-center gap-2">
                    <!-- <button
                        (click)="onConfirmGroup()" _ngcontent-cic-c118="" type="button"
                        class="btn-gl-save btn-dark-hover btn-sm w-25 my-4"
                        [disabled]="loading">
                        Siguiente
                    </button> -->
                    <button
                        (click)="backToPreview()" _ngcontent-cic-c118="" type="button"
                        class="btn-gl-neutral btn-dark-hover btn-sm w-25 my-4"
                        *ngIf="this.showSaveMultiview">
                        Atras
                    </button> 
                    <button
                        (click)="onConfirm()" _ngcontent-cic-c118="" type="button"
                        class="btn-gl-save btn-dark-hover btn-sm w-25 my-4"
                        [disabled]="loading">
                        {{'GENERAL.NEXT' | translate}}
                    </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</p-dialog>
